import { render } from "./FaceMergeModal.vue?vue&type=template&id=a2888d84&scoped=true&ts=true"
import script from "./FaceMergeModal.vue?vue&type=script&lang=ts"
export * from "./FaceMergeModal.vue?vue&type=script&lang=ts"

import "./FaceMergeModal.vue?vue&type=style&index=0&id=a2888d84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2888d84"]])

export default __exports__